<template>
  <div class="main-div">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inconsolata&display=swap');

:root {
  box-sizing: border-box;
  color: $smoke-gray;
}

*,
::before,
::after {
  box-sizing: inherit;
}

html {
  height: 100%;
  width: 100%;
}

// min-height: 0vh is required for Safari, or else min() will not work
// The "vh" is necessary. Just 0 will not work.
body {
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: $natural-white;
  font-size: min(1.2vw, 1em);
  min-height: 0vh;
}

.main-div {
  // font-family: 'Nunito', sans-serif;
  font-family: 'Inter', sans-serif;
}
</style>
